import { Injectable } from '@angular/core';



@Injectable()
export class HelperService {
    allacceptedExtention: Array<string> =  ['docx', 'pdf', 'PDF',
                                        'jpg', 'jpeg','png', 'PNG',
                                         'JPG', 'JPEG',
                                        'txt', 'xlsx', 'xls', 'doc', 'xml', 'zip', 'rar', 'msg'
                                    ];
    acceptedExtentionPicAndPdf: Array<string> =  ['pdf', 'jpg', 'jpeg', 'png'];
    constructor() { }

    fileExtention(name: string) {
        const regex = /(?:\.([^.]+))?$/;
        return regex.exec(name)[1];
    }

}